export default __webpack_public_path__ + "static/scientific-advancement-mobile-dd5639d907841af30ac8a74f29e9905f.png";